import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import style from './Navbar.module.css';
import logo from '../Assets/logo/logo.png';

import SearchBar from './Search bars/Search';

import icon1 from '../Assets/icons/icon1.png';
import icon2 from '../Assets/icons/icon2.png';
import icon3 from '../Assets/icons/icon3.png';
import icon5 from '../Assets/icons/icon5.png';

export default function Navbar() {
  const location = useLocation();
  const [showMobileSearch, setShowMobileSearch] = useState(false);

  // Persian is the default language if no value exists
  const languagePicked =
    localStorage.getItem('siteLanguage') || 'fa';

  const isArabic = languagePicked === 'ar';

  const labels = isArabic
    ? {
        home: 'الصفحه الرئیسیه',
        speeches: 'خطابات',
        stories: 'حكايا',
        audios: 'صوت',
        productions: 'إنتاجات',
        search: 'البحث',
        closeSearch: 'إغلاق البحث',
        logoAlt: 'الشعار',
      }
    : {
        home: 'صفحه اصلی',
        speeches: 'بیانات',
        stories: 'داستان‌ها',
        audios: 'صوت',
        productions: 'تولیدات',
        search: 'جستجو',
        closeSearch: 'بستن جستجو',
        logoAlt: 'لوگو',
      };

  const isActive = (path) => {
    if (path === '/home') {
      return (
        location.pathname === '/home' ||
        location.pathname === '/'
      );
    }

    return location.pathname.startsWith(path);
  };

  const handleSearchClick = () => {
    setShowMobileSearch((currentValue) => !currentValue);
  };

  return (
    <>
      {/* Desktop Navbar */}
      <div className={`${style.topBar} ${style.desktopNavbar}`}>
        <div className={style.container}>
          <div className={style.logo}>
            <Link to="/home">
              <img src={logo} alt={labels.logoAlt} />
            </Link>
          </div>

          <div className={style.mainDiv}>
            <ul className={style.menu}>
              <li>
                <Link
                  className={`${style.links} ${
                    isActive('/home') ? style.active : ''
                  }`}
                  to="/home"
                >
                  {labels.home}
                </Link>
              </li>

              <li>
                <Link
                  className={`${style.links} ${
                    isActive('/speeches') ? style.active : ''
                  }`}
                  to="/speeches"
                >
                  {labels.speeches}
                </Link>
              </li>

              <li>
                <Link
                  className={`${style.links} ${
                    isActive('/stories') ? style.active : ''
                  }`}
                  to="/stories"
                >
                  {labels.stories}
                </Link>
              </li>

              <li>
                <Link
                  className={`${style.links} ${
                    isActive('/audios') ? style.active : ''
                  }`}
                  to="/audios"
                >
                  {labels.audios}
                </Link>
              </li>

              <li>
                <Link
                  className={`${style.links} ${
                    isActive('/productions') ? style.active : ''
                  }`}
                  to="/productions"
                >
                  {labels.productions}
                </Link>
              </li>
            </ul>
          </div>

          <div className={style.desktopSearch}>
            <SearchBar />
          </div>
        </div>
      </div>

      {/* Mobile Bottom Navbar */}
      <div className={style.mobileBottomNav}>
        <div className={style.mobileNavContainer}>
          <Link
            to="/home"
            className={`${style.navItem} ${
              isActive('/home') ? style.active : ''
            }`}
          >
            <div className={style.navContent}>
              <div className={style.navIcon}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                </svg>
              </div>

              <span className={style.navLabel}>
                {labels.home}
              </span>
            </div>
          </Link>

          <Link
            to="/speeches"
            className={`${style.navItem} ${
              isActive('/speeches') ? style.active : ''
            }`}
          >
            <div className={style.navContent}>
              <div className={style.navIcon}>
                <img src={icon2} alt={labels.speeches} />
              </div>

              <span className={style.navLabel}>
                {labels.speeches}
              </span>
            </div>
          </Link>

          <Link
            to="/stories"
            className={`${style.navItem} ${
              isActive('/stories') ? style.active : ''
            }`}
          >
            <div className={style.navContent}>
              <div className={style.navIcon}>
                <img src={icon5} alt={labels.stories} />
              </div>

              <span className={style.navLabel}>
                {labels.stories}
              </span>
            </div>
          </Link>

          <Link
            to="/audios"
            className={`${style.navItem} ${
              isActive('/audios') ? style.active : ''
            }`}
          >
            <div className={style.navContent}>
              <div className={style.navIcon}>
                <img src={icon3} alt={labels.audios} />
              </div>

              <span className={style.navLabel}>
                {labels.audios}
              </span>
            </div>
          </Link>

          <Link
            to="/productions"
            className={`${style.navItem} ${
              isActive('/productions') ? style.active : ''
            }`}
          >
            <div className={style.navContent}>
              <div className={style.navIcon}>
                <img src={icon1} alt={labels.productions} />
              </div>

              <span className={style.navLabel}>
                {labels.productions}
              </span>
            </div>
          </Link>
        </div>
      </div>

      {/* Floating Search Button on Mobile */}
      <button
        className={style.floatingSearchBtn}
        onClick={handleSearchClick}
        aria-label={labels.search}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
        </svg>
      </button>

      {/* Mobile Search Overlay */}
      {showMobileSearch && (
        <div
          className={style.mobileSearchOverlay}
          onClick={handleSearchClick}
        >
          <div
            className={style.mobileSearchContainer}
            onClick={(event) => event.stopPropagation()}
          >
            <div className={style.mobileSearchHeader}>
              <h3 className={style.mobileSearchTitle}>
                {labels.search}
              </h3>

              <button
                className={style.closeSearchBtn}
                onClick={handleSearchClick}
                aria-label={labels.closeSearch}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
              </button>
            </div>

            <SearchBar />
          </div>
        </div>
      )}
    </>
  );
}
